import seatComponents from "../seatComponents";

// Always show 3 controls for MTCL regardless of seat
const mvmtControls = ({ selected, options: initialOptions }) => {
  let options = initialOptions;
  const { series, performance } = selected;
  if (series !== "MTCL") return { selected, options };

  // build list of available control options. If the performance package is ISO5, ISO5K, ISO3, ISO3K only allow FFAC, otherwise allow T, FFAC, and E3
  const isISO3or5 = ["ISO3", "ISO3K", "ISO5", "ISO5K"].includes(performance);
  const allowedControlCodes = isISO3or5 ? ["FFAC"] : ["T", "FFAC", "E3"];

  const [allControls] = seatComponents.filter(({ type }) => type === "control");
  const controls = allControls.data.filter(({ code }) => allowedControlCodes.indexOf(code) !== -1);

  options = options.map((option) => {
    const { type } = option;
    if (type === "control") return { ...option, data: controls };
    return option;
  });

  return { selected, options };
};

export default mvmtControls;
